// Calendar: monthIndex 0 = January 1988. No Date objects anywhere in the engine.

export const EPOCH_YEAR = 1988;

export function yearOf(monthIndex: number): number {
  return EPOCH_YEAR + Math.floor(monthIndex / 12);
}

export function monthOfYear(monthIndex: number): number {
  return (monthIndex % 12) + 1; // 1..12
}

export function monthLabel(monthIndex: number): string {
  const names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${names[monthIndex % 12]} ${yearOf(monthIndex)}`;
}

/** Months since epoch for a calendar year's January (year >= 1988). */
export function januaryOf(year: number): number {
  return (year - EPOCH_YEAR) * 12;
}

import type { CurvePoint } from "./types.js";

/** Piecewise-linear interpolation over monthIndex, clamped at both ends. Points must be sorted by m. */
export function interpolate(curve: CurvePoint[], m: number): number {
  if (curve.length === 0) throw new Error("empty curve");
  const first = curve[0]!;
  if (m <= first.m) return first.v;
  const last = curve[curve.length - 1]!;
  if (m >= last.m) return last.v;
  for (let i = 1; i < curve.length; i++) {
    const b = curve[i]!;
    if (m <= b.m) {
      const a = curve[i - 1]!;
      const t = (m - a.m) / (b.m - a.m);
      return a.v + t * (b.v - a.v);
    }
  }
  return last.v;
}
